<p>service-config-popup works!</p>
